import { render, staticRenderFns } from "./MenuListTableOne.vue?vue&type=template&id=83cf7ed0&scoped=true&"
import script from "./MenuListTableOne.vue?vue&type=script&lang=js&"
export * from "./MenuListTableOne.vue?vue&type=script&lang=js&"
import style0 from "./MenuListTableOne.vue?vue&type=style&index=0&id=83cf7ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cf7ed0",
  null
  
)

export default component.exports